module.exports = "<things-form title=\"Edit About for \" key=\"thingsEdit.open\" [onSubmit]=\"submit.bind(this)\" [thingType]=type></things-form>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/things/edit/edit.component.html
// module id = ../../../../../src/app/components/things/edit/edit.component.html
// module chunks = main